import { all, fork } from "redux-saga/effects";
import { listAllRequestsWatcherSaga } from "./all-requests/list.saga";
import { listOwnRequestsWatcherSaga } from "./own-requests/list.saga";
import { listParticipantsRequestsWatcherSaga } from "./participants-requests/list.saga";
import { searchAllRequestsWatcherSaga } from "./all-requests/search.saga";
import { searchOwnRequestsWatcherSaga } from "./own-requests/search.saga";
import { searchParticipantsRequestsWatcherSaga } from "./participants-requests/search.saga";
import { listWorkflowConfigurationWatcherSaga } from "./workflow-configuration/list.saga";
import { searchWorkflowConfigurationWatcherSaga } from "./workflow-configuration/search.saga";
import { listHistoryRequestsWatcherSaga } from "./history-requests/list.saga";
import { searchHistoryRequestsWatcherSaga } from "./history-requests/search.saga";

export default function* AppRootSaga() {
  yield all([
    fork(listAllRequestsWatcherSaga),
    fork(listOwnRequestsWatcherSaga),
    fork(listParticipantsRequestsWatcherSaga),
    fork(searchAllRequestsWatcherSaga),
    fork(searchOwnRequestsWatcherSaga),
    fork(searchParticipantsRequestsWatcherSaga),
    fork(listWorkflowConfigurationWatcherSaga),
    fork(searchWorkflowConfigurationWatcherSaga),
    fork(listHistoryRequestsWatcherSaga),
    fork(searchHistoryRequestsWatcherSaga),
  ]);
}
